import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Home, KeyRound, TrendingUp, Network } from 'lucide-react';

const ExpertiseSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  const expertiseItems = [
    {
      title: 'Immobilienkauf',
      description: 'Wir begleiten Sie von der Suche bis zum Abschluss, um Ihre Traumimmobilie zu finden und zu sichern.',
      icon: Home,
    },
    {
      title: 'Immobilienverkauf',
      description: 'Professionelle Bewertung, Vermarktung und Begleitung beim Verkauf Ihrer Immobilie zu optimalen Konditionen.',
      icon: TrendingUp,
    },
    {
      title: 'Immobilienprojekte',
      description: 'Wir entwickeln und realisieren innovative Wohn- und Gewerbeimmobilien mit zukunftsweisenden Konzepten.',
      icon: Building2,
    },
    {
      title: 'Vermietung',
      description: 'Umfassende Betreuung bei der Vermietung Ihrer Immobilie oder bei der Suche nach dem passenden Mietobjekt.',
      icon: KeyRound,
    },
    {
      title: 'Partnernetzwerk',
      description: 'Zugang zu unserem Netzwerk aus Finanzierungsexperten, Notaren, Architekten und Handwerkern.',
      icon: Network,
    },
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background abstract architectural elements */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]">
        <div className="absolute top-0 left-0 w-1/3 h-1/3 border-t-2 border-l-2 border-black"></div>
        <div className="absolute top-[40%] right-[30%] w-1/4 h-1/3">
          <div className="w-full h-full border-2 border-black rotate-12"></div>
        </div>
        <div className="absolute bottom-[20%] left-[15%] w-1/5 h-1/4">
          <div className="w-full h-full border-2 border-black -rotate-6"></div>
        </div>
        <div className="absolute bottom-[10%] right-[5%] w-1/4 h-1/5">
          <div className="w-full h-full border-2 border-black rotate-3"></div>
        </div>
        <div className="absolute top-[15%] right-[8%] w-1/6 h-1/6">
          <div className="w-8 h-8 border-2 border-black"></div>
        </div>
        <div className="absolute bottom-[30%] left-[40%]">
          <div className="w-16 h-16 rounded-full border-2 border-black"></div>
        </div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">Unsere Expertise</h2>
          <p className="text-gray-700 max-w-3xl mx-auto text-lg">
            Mit zukunftsweisenden Lösungen bieten wir umfassende Dienstleistungen rund um Immobilien.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {expertiseItems.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow rounded"
            >
              <div className="mb-6">
                <div className="w-14 h-14 rounded-full bg-[#00C2CC]/10 flex items-center justify-center">
                  <item.icon className="w-7 h-7 text-[#00C2CC]" />
                </div>
              </div>
              <h3 className="text-xl font-bold mb-3">{item.title}</h3>
              <p className="text-gray-600">{item.description}</p>
              <div className="mt-6">
                <a href="#" className="text-[#00C2CC] font-medium flex items-center hover:text-[#008a91] transition-colors">
                  Mehr erfahren
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
